import Index from '../../pages/servitor/anniversary/index';
import Pc from '../../pages/servitor/anniversary/index/pc.vue';
import Help from '../../pages/servitor/anniversary/help';

const base = 'anniversary';

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/help*`,
    name: `${base}-help`,
    component: Help
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  },
  
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/servitor/anniversary.js